module.exports = __webpack_public_path__ + "static/media/friday-che-big.79dfcf45.png";